import { useEffect } from 'react'
import { useForm } from 'react-final-form'
import { useSelector } from 'react-redux'
import { useStepper } from 'src/components/StepperWalliro/stepperContext'
import { providerNameSelector } from 'src/logic/wallets/store/selectors'
import { FIELD_STARTER_TYPE, TypeForm } from '../fields/starterFields'
import CreateWalliro from './Create'
import ReviewLoadStep from './Load'
const StepFive = () => {
  const provider = useSelector(providerNameSelector)

  const { setCurrentStep } = useStepper()

  useEffect(() => {
    if (!provider) {
      setCurrentStep(0)
    }
  }, [provider, setCurrentStep])

  const StarterForm = useForm()
  const StarterFormValues = StarterForm.getState().values
  if (StarterFormValues[FIELD_STARTER_TYPE] === TypeForm.open) {
    return <CreateWalliro />
  } else {
    return <ReviewLoadStep />
  }
}

export default StepFive
